import "./Portfolio.css";

const items = [
  { img:"https://res.cloudinary.com/deoeayyyc/f_auto,q_auto/images_production/2025/06/IMG_1606-scaled-e1749133258746.jpeg", cat:"Taman Kantor", name:"PT. MHI — Kolam & Taman", wide:true },
  { img:"https://infotraining-indonesia.com/wp-content/uploads/2017/12/PELATIHAN-LANDSCAPE-DAN-PERTAMANAN.jpg", cat:"Kawasan Industri", name:"Penghijauan PT. IMIP Morowali" },
  { img:"https://events.rumah123.com/wp-content/uploads/sites/38/2023/06/14170920/9.-Taman-Serba-Putih-yang-Dilengkapi-Kolam-Renang.jpg", cat:"Taman Perumahan", name:"Taman Perumahan Elite Kediri", tall:true },
  { img:"https://akcdn.detik.net.id/visual/2021/07/14/rencana-penutupan-pintu-keluar-tol-di-jawa-tengah_169.jpeg?w=1200", cat:"Infrastruktur", name:"Penghijauan Jalan Tol", wide:true },
  { img:"https://images.tokopedia.net/blog-tokopedia-com/uploads/2018/01/Blog_Judul-Blog2.jpg?w=400&auto=format&fit=crop", cat:"Taman Kota", name:"Taman Kota Kediri" },
];

export default function Portfolio() {
  return (
    <section className="portfolio" id="portofolio">
      <div className="portfolio__banner">
        <span className="eyebrow portfolio__banner-eyebrow">Portofolio Kami</span>
        <h2 className="portfolio__banner-title">Setiap Proyek <em>Penuh Dedikasi</em></h2>
        <p className="portfolio__banner-sub">Dipercaya berbagai kalangan untuk penghijauan skala kecil hingga proyek nasional.</p>
      </div>

      <div className="container portfolio__wrap">
        <div className="portfolio__grid">
          {items.map((p, i) => (
            <div
              key={i}
              className={`pf-item${p.wide ? ' pf-item--wide' : ''}${p.tall ? ' pf-item--tall' : ''}`}
            >
              <img src={p.img} alt={p.name} />
              <div className="pf-item__overlay">
                <div className="pf-item__cat">{p.cat}</div>
                <div className="pf-item__name">{p.name}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="portfolio__cta">
          <a href="#kontak" className="btn btn-green">Request Konsultasi Proyek</a>
        </div>
      </div>
    </section>
  );
}
